import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    margin: theme.spacing(1),
  },

  main: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    alignItems: 'center',
  },
  mainError: {
    display: 'flex',
    alignItems: 'center',
    height: '500px',
    justifyContent: 'center',
    gap: '70px',
    flexDirection: 'column',
  },
  title: {
    //margin: '0 0 24px',
    //marginTop: theme.spacing(1),
    fontSize: 25,
    color: 'black',
  },
  paper: {
    marginTop: theme.spacing(15),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 15,
  },
  formControl: {
    width: '100%',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  submitBtn: {
    width: '100%',
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(1),
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
}));
